<template>
  <div>
    <b-row v-if="type == 'community'">
      <b-col cols="10" offset="1">
        <b-row class="justify-content-center">
          <b-col
            cols="12"
            md="6"
            lg="3"
            v-for="(item, index) in community_top5"
            :key="index"
          >
            <div class="mt-3">
              <b-card
                :class="[item.style, 'rank-card1']"
                :footer-class="item.card"
              >
                <b-card-text style="background-color: white">
                  <img
                    src="../assets/icons/icons_general/icon_place.svg"
                    width="30"
                    height="30"
                  />
                  <p class="my-3">{{ item.name }}</p>
                </b-card-text>
                <template #footer> {{ item.number }} ครั้ง</template>
              </b-card>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="type == 'bio'">
      <b-col cols="10" offset="1">
        <b-row class="justify-content-center">
          <b-col cols="6" md="2" v-for="(item, i) in categoey_top5" :key="i">
            <div class="mt-3">
              <b-card
                :class="[item.style, 'rank-card2']"
                :footer-class="item.card"
              >
                <b-card-text style="background-color: white; height: 50%">
                  <img :src="item['img']" width="30" height="30" alt="" />
                  <p class="my-3">{{ item["title"] }}</p>
                </b-card-text>
                <template #footer>
                  <div class="font-sub-title">
                    {{ item.number }}
                    <div>ครั้ง</div>
                  </div>
                </template>
              </b-card>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import icon1 from "@/assets/icons/icons_general/icon_herb.svg";
import icon2 from "@/assets/icons/icons_general/icon_flower.svg";
import icon3 from "@/assets/icons/icons_general/fruits.png";
import icon4 from "@/assets/icons/icons_general/icon_broccoli.svg";
import icon5 from "@/assets/icons/icons_general/icon_potatoes.svg";
import icon6 from "@/assets/icons/icons_general/icon_seeds.svg";
import { mapState } from "vuex";
export default {
  name: "popular_search",
  props: {
    type: null,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  computed: {
    ...mapState({
      community_top5: (state) => {
        return state.dashboardModule.community_top5;
      },
      categoey_top5: (state) => {
        state.dashboardModule.category_top5.forEach((item) => {
          switch (item.img) {
            case 1:
              item.img = icon1;
              break;
            case 2:
              item.img = icon2;
              break;
            case 3:
              item.img = icon3;
              break;
            case 4:
              item.img = icon4;
              break;
            case 5:
              item.img = icon5;
              break;
            case 6:
              item.img = icon6;
              break;
          }
        });
        return state.dashboardModule.category_top5;
      },
    }),
  },
};
</script>

<style scoped>
.rank-card1 {
  width: 200px;
  height: 250px;
  font-size: 14px;
  margin: auto;
  border-radius: 5%;
}
.rank-card2 {
  width: 117px;
  height: 150px;
  font-size: 14px;
  margin: auto;
  border-radius: 5%;
}

div.card.card-style1 {
  border: #41634a solid 2px;
}

div.card.card-style2 {
  border: #5a7e64 solid 2px;
}

div.card.card-style3 {
  border: #7f8563 solid 2px;
}

div.card.card-style4 {
  border: #db7f50 solid 2px;
}

div.card.card-style5 {
  border: #e9a37f solid 2px;
}

div.card-body {
  padding: 15% 0 0 0;
}

div.card1 {
  height: 40%;
  background-color: #41634a;
  color: white;
  font-size: 20px;
}

div.card2 {
  height: 40%;
  background-color: #5a7e64;
  color: white;
  font-size: 20px;
}

div.card3 {
  height: 40%;
  background-color: #7f8563;
  color: white;
  font-size: 20px;
}

div.card4 {
  height: 40%;
  background-color: #db7f50;
  color: white;
  font-size: 20px;
}

div.card5 {
  height: 40%;
  background-color: #e9a37f;
  font-size: 20px;
}
</style>
